'use client';
import { Section } from '@/components/screen-scroll';
import { PcTitle } from '@/components/title';
import { useMemo, useRef, useState } from 'react';
import CreationCard from '../components/creation-card';
import arrow_left from './images/arrow-left.png';
import arrow_right from './images/arrow-right.png';
import { getDoubleDimensional } from '@/utils';
import { CosImage } from '@ssv-website/web-ui';
const default_size = 4;
const CoCreation = ({ data }: { data: HomePageTypes.Article }) => {
  const { total, data: list } = data;
  const ref = useRef<HTMLDivElement>(null);

  const [page, setPage] = useState(1);

  const page_total = total ? Math.ceil(total / default_size) : 1;
  const changePageRender = (type: 'next' | 'prev') => {
    if (ref.current) {
      const offSetWidth = ref.current.offsetWidth;
      const scrollLeft = ref.current.scrollLeft;
      const leftMap = {
        next: scrollLeft + offSetWidth,
        prev: scrollLeft - offSetWidth,
      };
      ref.current?.scrollTo({
        left: leftMap[type],
        behavior: 'smooth',
      });
    }
  };

  const init_list = useMemo(() => getDoubleDimensional(list, 4), []);
  const next = async () => {
    if (page >= page_total) return;

    changePageRender('next');
  };
  const prev = async () => {
    if (page <= 1) return;
    changePageRender('prev');
  };
  const onScroll = () => {
    if (ref.current) {
      const offSetWidth = ref.current.offsetWidth;
      const scrollLeft = ref.current.scrollLeft;
      const current = Math.round(scrollLeft / offSetWidth);
      setPage(current + 1);
    }
  };

  return (
    <Section className="bg-[#F5F9FF]">
      <PcTitle title="共创项目" description={description} />
      <div className="px-[6.7rem] w-full overflow-hidden flex flex-col items-center">
        <div className="w-full  max-w-[107rem] box-border mb-[1.68rem] flex items-center">
          <span className="text-primary text-2xl font-500">
            共 {total ?? 0} 个项目
          </span>
        </div>

        <div
          className="w-full  max-w-[107rem]  flex overflow-x-auto gap-6 hide-scrollbar flex-nowrap overflow-y-hidden box-border snap-x snap-mandatory"
          ref={ref}
          onScroll={onScroll}
        >
          {init_list?.map((item, index) => (
            <div
              className="grid grid-cols-4 flex-shrink-0 gap-6 w-full snap-center snap-always"
              key={index}
            >
              {item?.map((v, i) => (
                <div className=" flex-shrink-0" key={v.title + i}>
                  <CreationCard
                    title={v.title}
                    text={v.description}
                    imgUrl={v.cover}
                    count={10}
                    link={v.link}
                    isMobile={false}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-8">
          <Paging total={page_total} next={next} prev={prev} page={page} />
        </div>
      </div>
    </Section>
  );
};

export default CoCreation;

const description = [
  '通过观念共识，促成行动共进，实现价值共享',
  '通过共创，促进规模化和社会影响的延伸，将善的同心圆不断扩大',
];
interface IPaging {
  page: number;
  next: () => void;
  prev: () => void;
  total: number;
}
const Paging = ({ page, next, prev, total }: IPaging) => {
  const isMin = page <= 1;
  const isMax = page >= total;
  return (
    <div className="flex items-center">
      <CosImage
        fallbackSrc={isMin ? arrow_left : arrow_right}
        path={
          isMin
            ? '/ssv-home/app/home/desktop-section/images/arrow-left.png'
            : '/ssv-home/app/home/desktop-section/images/arrow-right.png'
        }
        alt=""
        className={`w-10 h-10 cursor-pointer ${isMin ? '' : 'rotate-180'}`}
        onClick={prev}
      />

      <div className="px-[1.37rem] text-sm font-400 flex">
        <span>{page}</span>
        <span className="text-[#323C46] ml-[0.12rem]">/ {total}</span>
      </div>
      <CosImage
        fallbackSrc={isMax ? arrow_left : arrow_right}
        path={
          isMax
            ? '/ssv-home/app/home/desktop-section/images/arrow-left.png'
            : '/ssv-home/app/home/desktop-section/images/arrow-right.png'
        }
        alt=""
        className={`w-10 h-10 cursor-pointer ${isMax ? 'rotate-180' : ''}`}
        onClick={next}
      />
    </div>
  );
};
